import { render } from "./뇌혈관센터.vue?vue&type=template&id=1cfac5fa"
import script from "./뇌혈관센터.vue?vue&type=script&lang=js"
export * from "./뇌혈관센터.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__